import { render, staticRenderFns } from "./CirclePlusIcon.vue?vue&type=template&id=2013b640&scoped=true"
import script from "./CirclePlusIcon.vue?vue&type=script&lang=js"
export * from "./CirclePlusIcon.vue?vue&type=script&lang=js"
import style0 from "./CirclePlusIcon.vue?vue&type=style&index=0&id=2013b640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2013b640",
  null
  
)

export default component.exports